import { supabase } from './supabaseClient'

export type UpdateWorkoutTimeResult = {
  schedule_id: string
  start_time: string
  end_time: string
  calendar_synced: boolean
  error?: string
}

export async function updateWorkoutScheduleTime(
  scheduleId: string,
  startTime: string,
  endTime: string,
  options?: { updateProfilePreference?: boolean; syncCalendar?: boolean },
): Promise<{ data: UpdateWorkoutTimeResult | null; error: string | null }> {
  const { data, error } = await supabase.functions.invoke('update-training-schedule-time', {
    body: {
      schedule_id: scheduleId,
      start_time: startTime,
      end_time: endTime,
      update_profile_preference: options?.updateProfilePreference ?? true,
      sync_calendar: options?.syncCalendar ?? true,
    },
  })

  if (error) return { data: null, error: error.message }
  if (data?.error) return { data: null, error: String(data.error) }
  return { data: data as UpdateWorkoutTimeResult, error: null }
}
